import {VmButton, VmText, VmView} from 'components'
import HStack from 'components/HStack'
import {
  fetchCetak,
  formatCetakJumlahGidion,
  formatTanggalLahirCetak,
} from './api'
import trans_bg from 'assets/trans_bg.png'

import moment from 'moment'
import React, {useState} from 'react'
import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {sleep} from 'pages/prd-penjualan-obat-resep/utils'
import {
  areCetakImagesReady,
  bindCetakImageRef,
  isStempelEnabled,
  isTtdEnabled,
  markCetakImageReady,
  preloadCetakImage,
  waitForPrintPaint,
} from './cetakResepUtils'

// Lebar 1 faktur = 1/3 kertas A4 landscape (297mm - margin 8mm) / 3 ≈ 96mm
const FAKTUR_WIDTH = '96mm'

export default function CetakGidion() {
  const params = useParams()
  const [data, setdata] = useState({
    detail: {
      head: {
        pjid: '',
      },
      child: [],
    },
  })
  const [imageLoad, setimageLoad] = useState({stempel: false, ttd: false})
  const [isPrinting, setisPrinting] = useState(true)

  const navigate = useNavigate()

  useEffect(() => {
    const init = async () => {
      const resCetak = await fetchCetak(params.uid, params.id)
      setdata(resCetak)
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!data?.stg) return

    if (isTtdEnabled(data.stg)) {
      preloadCetakImage(data.stg.user_ttd, 'ttd', setimageLoad)
    }
    if (isStempelEnabled(data.stg)) {
      preloadCetakImage(data.stg.user_stempel, 'stempel', setimageLoad)
    }
  }, [data?.stg])

  useEffect(() => {
    const exec = async () => {
      setisPrinting(true)
      await sleep(500)

      if (!data?.detail?.head?.pjid || data?.e) return
      if (!areCetakImagesReady(data.stg, imageLoad)) return

      await waitForPrintPaint()
      window.print()
      setisPrinting(false)
    }
    exec()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.detail?.head?.pjid, data?.stg, imageLoad])

  const onImageLoad = type => markCetakImageReady(setimageLoad, type)

  if (data?.e)
    return (
      <VmView className="fixed h-full inset-0 text-center flex items-center">
        <VmText>Terjadi kesalahan saat cetak, silakan coba kembali</VmText>
      </VmView>
    )

  return (
    <>
      <style>{`
        .gidion-cetak-page {
          background: #f0f0f0;
          min-height: 100vh;
          padding: 12px;
        }

        .gidion-cetak-faktur {
          width: ${FAKTUR_WIDTH};
          max-width: 33.333%;
          padding: 8px;
          background: #fff;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        }

        @media print {
          @page {
            size: A4 landscape;
            margin: 4mm;
          }

          body {
            margin: 0 !important;
            padding: 0 !important;
            background: #fff !important;
          }

          .gidion-cetak-page {
            background: #fff !important;
            padding: 0 !important;
            min-height: auto !important;
          }

          .gidion-cetak-faktur {
            width: 33.333% !important;
            max-width: 33.333% !important;
            padding: 2mm !important;
            box-shadow: none !important;
            page-break-inside: avoid;
          }

          .notprint {
            display: none !important;
          }

          .gidion-cetak-ttd img {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      <VmView className="gidion-cetak-page">
        <VmView className="gidion-cetak-faktur">
          <HStack align="start" className="mb-2">
            <img
              src="https://gfsb.vmedis.com/foto/logo_4067_20240726122525.png"
              alt="logo"
              className="w-14 shrink-0"
            />
            <p className="flex-1 text-center text-xs font-bold self-center">
              Resep Digital
            </p>
            <VmView className="w-14 shrink-0" />
          </HStack>

          <p className="text-sxs font-bold">No. Resep</p>
          <HStack justify="between">
            <p className="text-sxs">{data?.detail?.head.pjnofaktur || '-'}</p>
            <p className="text-sxs">
              {data?.detail?.head?.pjtanggal
                ? moment(data.detail.head.pjtanggal).format('DD MMM YYYY')
                : '-'}
            </p>
          </HStack>

          <VmView className="border-y border-black py-2 my-2 grid grid-cols-2 items-start gap-1">
            <VmView>
              <table className="border-none w-full">
                <tbody>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Dokter</p>
                    </td>
                    <td>
                      <p className="text-sxs">
                        {data?.identitas?.nama_lengkap || '-'}
                      </p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">SIP</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.identitas?.user_nosip || '-'}</p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Spesialis</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.identitas?.ket_suspend || '-'}</p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">No. Telp</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.identitas?.user_wa || '-'}</p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Alamat</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.identitas?.alamat || '-'}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </VmView>

            <VmView>
              <table className="border-none w-full">
                <tbody>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Pasien</p>
                    </td>
                    <td>
                      <p className="text-sxs">
                        {data?.detail?.head?.pasrm
                          ? `${data.detail.head.pasrm} / ${
                              data?.detail?.head?.pasnama || '-'
                            }`
                          : data?.detail?.head?.pasnama || '-'}
                      </p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">No. WA</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.detail?.head?.pastelp || '-'}</p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Jenis Kelamin</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data?.detail?.head?.pasjk || '-'}</p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Tanggal Lahir</p>
                    </td>
                    <td>
                      <p className="text-sxs">
                        {formatTanggalLahirCetak(data?.detail?.head?.pastgllahir)}
                      </p>
                    </td>
                  </tr>
                  <tr className="align-top">
                    <td>
                      <p className="text-sxs font-bold mr-1">Alamat</p>
                    </td>
                    <td>
                      <p className="text-sxs">{data.detail.head.pasalamat || '-'}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </VmView>
          </VmView>

          <HStack className="mb-2">
            <p className="flex-[0.4] text-sxs font-bold">Obat</p>
            <p className="flex-[0.4] text-sxs font-bold mx-1">Aturan Pakai</p>
            <p className="flex-[0.2] text-sxs font-bold">Jumlah</p>
            <p className="flex-[0.2] text-sxs font-bold">Ket</p>
          </HStack>

          {data.detail?.child.length > 0 &&
            data.detail?.child.map((item, i) => (
              <HStack align="start" className="mb-2" key={i}>
                <p className="flex-[0.4] text-sxs font-bold break-words">
                  {item.pjdnama ? `R/ ${item.pjdnama}` : '-'}
                </p>
                <p className="flex-[0.4] text-sxs mx-1 break-words">
                  {item.pjdcatatan || '-'}
                </p>
                <p className="flex-[0.2] text-sxs break-words">{`${formatCetakJumlahGidion(item.pjdjumlah)} ${item.pjdsatuan}`}</p>
                <p className="flex-[0.2] text-sxs">
                  {item?.pjdjumlahresep - item?.pjdjumlah > 0 ? 'NDET' : 'DET' || '-'}
                </p>
              </HStack>
            ))}

          <VmView className="mt-4 pt-2">
            <VmView className="ml-auto mr-4 w-max min-w-40 max-w-full">
              {(() => {
                const ttd = isTtdEnabled(data?.stg)
                const stempel = isStempelEnabled(data?.stg)
                if (!ttd && !stempel) return null

                return (
                  <VmView className="gidion-cetak-ttd relative mb-1 h-24 w-full overflow-hidden">
                    {stempel && (
                      <img
                        alt="stempel-dokter"
                        ref={bindCetakImageRef('stempel', setimageLoad)}
                        className="absolute inset-0 h-full w-full object-contain opacity-25"
                        src={data?.stg?.user_stempel || trans_bg}
                        onLoad={() => onImageLoad('stempel')}
                        onError={() => onImageLoad('stempel')}
                      />
                    )}
                    {ttd && (
                      <img
                        alt="ttd-dokter"
                        ref={bindCetakImageRef('ttd', setimageLoad)}
                        className="absolute bottom-0 left-0 right-0 z-10 h-16 w-full object-contain object-bottom"
                        src={data?.stg?.user_ttd || trans_bg}
                        onLoad={() => onImageLoad('ttd')}
                        onError={() => onImageLoad('ttd')}
                      />
                    )}
                  </VmView>
                )
              })()}
              <p className="whitespace-nowrap px-1 text-center text-sxs">
                {data?.identitas?.nama_lengkap}
              </p>
            </VmView>
          </VmView>
        </VmView>
      </VmView>

      {!isPrinting && (
        <VmView className="notprint flex justify-end m-5">
          <VmButton color="danger" onClick={() => navigate(-1)}>
            Kembali
          </VmButton>
        </VmView>
      )}
    </>
  )
}
